import { BaseService, RequestType } from "@intech/react-service";
import { DadosPessoaisEntidade } from "../entidades";

class DadosPessoais extends BaseService {

  constructor() {
    super("dadosPessoais");
  }

  Buscar = () => this.CreateRequest<DadosPessoaisEntidade>(RequestType.GET);
}

export const DadosPessoaisService = new DadosPessoais();